<template>
    <div id="app">
        <NavBar @openModal="openModal"/>

        <main class="container-fluid d-flex pt-3 flex-column min-vh-100">
            <RouterView />
            <Footer @openModal="openModal"/>
            <ContactModal />
        </main>
    </div>
</template>

<script>
    import ContactModal from '@/components/ContactModal.vue';
    import Footer from '@/components/Footer.vue';
    import NavBar from '@/components/NavBar.vue';

    export default {
        name: 'App',
        components: {
            ContactModal,
            Footer,
            NavBar,
        },
        created() {
            console.log('( ^_^）o自自o（^_^ )');
            console.log('This website was designed and built by David Bane');
        },
        methods: {
            openModal() {
                this.$bvModal.show('contact-modal');
            }
        }

    }
</script>

<style lang="sass">
    @import "custom"

    #app
        background-color: #F8FAFC
        background-image: radial-gradient(1000px 250px at 10% -50%, rgba(44,103,0,0.08) 0%, rgba(44,103,0,0.00) 100%), radial-gradient(800px 220px at 90% 120%, rgba(255,207,121,0.10) 0%, rgba(255,207,121,0.00) 100%)
</style>
